import { useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

/**
 * Exporta um elemento (via ref) como PDF A4, com quebra de páginas automática.
 * props:
 *  - targetRef: ref do elemento que será “fotografado”
 *  - filename: nome do arquivo PDF
 *  - className: estilos do botão
 */
export default function PdfExportButton({ targetRef, filename = "consulta-placa.pdf", className = "" }) {
  const [working, setWorking] = useState(false);

  async function exportPDF() {
    if (!targetRef?.current) return;
    setWorking(true);
    try {
      const node = targetRef.current;

      // aumenta a qualidade do raster (scale 2)
      const canvas = await html2canvas(node, {
        scale: 2,
        backgroundColor: "#ffffff",
        useCORS: true,
        logging: false,
        windowWidth: document.documentElement.scrollWidth,
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.95);
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // dimensiona proporção
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(filename);
    } finally {
      setWorking(false);
    }
  }

  return (
    <button type="button" className={`btn ${className}`} onClick={exportPDF} disabled={working}>
      {working ? "Gerando PDF…" : "Exportar PDF"}
    </button>
  );
}
